module.exports = __webpack_public_path__ + "img/20191207152800360截图20191207151357443.77944bd6.jpg";